export default {
  images: {
    items: {
      'ui:widget': 'EditorUploadWidget',
    },
  },
  text: {
    'ui:widget': 'EditorMarkdownWidget',
  },
  buttons: {
    items: {
      color: {
        'ui:widget': 'BaseColorWidget',
      },
      textColor: {
        'ui:widget': 'BaseColorWidget',
      },
    },
  },
}
